import ShopBasketModelBase from '../_generated/modelBases/shop-basket-model-base';

export default class ShopBasketModel extends ShopBasketModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
